import React from 'react';

interface Props {
  readonly children?: React.ReactNode;
  onSubmit?(event: React.FormEvent<HTMLFormElement>): any;
}

const Form: React.FC<Props> = ({ children, onSubmit }: Props) => {
  return (
    <>
      <form onSubmit={onSubmit}>{children}</form>
    </>
  );
};

export default Form;
